export enum DatabaseLongTermRetentionPeriod {
    NinetyDays = "NinetyDays",
    ThreeYears = "ThreeYears",
}